import { render, staticRenderFns } from "./ConsultarAtas.vue?vue&type=template&id=266be528&scoped=true"
import script from "./ConsultarAtas.vue?vue&type=script&lang=js"
export * from "./ConsultarAtas.vue?vue&type=script&lang=js"
import style0 from "./ConsultarAtas.vue?vue&type=style&index=0&id=266be528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266be528",
  null
  
)

export default component.exports